/* eslint-disable no-unused-vars*/

import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import { GET_NOTEPAD, UPDATE_NOTEPAD } from "./actionTypes";
import {
  apiError,
  loadNotepad,
  updateNotepaduccess,
  setNotepadContent,
} from "./actions";

import axios from "axios";

function* getNotepad() {
  try {
    const response = yield call(axios.get, `/notepad`);
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(loadNotepad(response.data.data));
      yield put(setNotepadContent(response.data.data.notepads[0].text));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      //TODO: Incluir os tratamento necessário para apresentar os erros corretos
      switch (error.response.status) {
        case 401:
          message = "Your session has expired";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
  }
}

function* updateNotepad({ payload: { notepadValues } }) {
  try {
    const response = yield call(axios.patch, `/notepad`, notepadValues);
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message ? response.data.message : "";
      yield put(updateNotepaduccess(message));
      try {
        const response = yield call(axios.get, `/flash-message`);
        if (
          (response.status >= 200 || response.status <= 299) &&
          response.data &&
          response.data.data
        ) {
          yield setTimeout(() => {
            put(loadNotepad(response.data.data));
          }, 3000);
        } else throw response.data;
      } catch (error) {
        let message;
        if (error.response && error.response.status) {
          switch (error.response.status) {
            case 401:
              message = "Your session has expired";
              break;
            case 500:
              message =
                "Sorry! something went wrong, please contact our support team";
              break;
            default:
              if (error.response.data && error.response.data.message)
                message = error.response.data.message;
              else message = error.message;
              break;
          }
        }
      }
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 400:
          message = "Invalid data";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

export function* watchGetNotepad() {
  yield takeEvery(GET_NOTEPAD, getNotepad);
}

export function* watchUpdateNotepad() {
  yield takeEvery(UPDATE_NOTEPAD, updateNotepad);
}

function* authSaga() {
  yield all([fork(watchGetNotepad), fork(watchUpdateNotepad)]);
}

export default authSaga;
